import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const homepage = createAsyncThunk(
  'Saada/saadaUnionExportRevenue/export_pearl_statement_by_union_homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/export_pearl_statement_by_union_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const export_pearl_statement_by_union = createAsyncThunk(
  'Saada/saadaUnionExportRevenue/export_pearl_statement_by_union',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/export_pearl_statement_by_union',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  home?: {
    email?: ''
  }
}

const initialState: InitialStateType = {}

export const SaadaUnionExportRevenueSlice = createSlice({
  name: 'Animal_Lemur',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {home: action.payload})
    })
  },
})
export default SaadaUnionExportRevenueSlice.reducer
export const SaadaUnionExportRevenueActions =
  SaadaUnionExportRevenueSlice.actions

export const useSaadaUnionExportRevenueState = () => {
  const data = useSelector((state) => {
    return state.Animal_Lemur
  })
  return data
}
